import { useFlippers } from "@shared/context/FlippersContext";
import { useUnauthedExperiment } from "@shared/hooks/useExperiment/useUnauthedExperiment";

const useLoginAppBanner = () => {
  const [isLoginAppBannerEnabled, isForceEnabled] = useFlippers(
    "oliver_login_app_banner",
    "oliver_login_app_banner_force_enable"
  );

  const experimentGroup = useUnauthedExperiment({
    experiment: "oliver_login_app_banner",
    groups: ["CONTROL", "EXPERIMENT"],
    shouldLog: isLoginAppBannerEnabled,
  });

  if (isForceEnabled && isLoginAppBannerEnabled) {
    return true;
  }

  return isLoginAppBannerEnabled && experimentGroup === "EXPERIMENT";
};

export { useLoginAppBanner };
